import React from "react";
import { Col, Row } from "react-bootstrap";

export default function ParameterProgressBar({ name, score }) {
  if (score <= 0) score = 0;
  else score = Number(score).toFixed(1);

  const progressColor = "#4a90e2";
  const backgroundColor = "#e0e0e0";

  return (
    <Row className="mb-2">
      <Col xs="3" className="align-content-center">
        <div style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>{name}</div>
      </Col>
      <Col xs="9" className="align-content-center">
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* Percentage text */}
          <div
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#333",
              minWidth: "65px",
            }}
          >
            {score}%
          </div>

          {/* Loading bar */}
          <div
            style={{
              flex: 1,
              height: "24px",
              backgroundColor: backgroundColor,
              borderRadius: "12px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${score}%`,
                backgroundColor: progressColor,
                borderRadius: "12px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
